export default "__VITE_ASSET__CghdKJaE__"